import BrandProducts from './BrandProducts.Container';

export default BrandProducts;
